import service from '@/utils/https';
import type { LoginRequest, TokenResponse, LogoutRequest, RefreshTokenRequest, ApiResponse, AdminResponse } from '@/types';

export const login = (data: LoginRequest) => {
  return service.post<ApiResponse<TokenResponse>>('/api/v1/admin/auth/login', data);
};

export const refresh = (data: RefreshTokenRequest) => {
  return service.post<ApiResponse<TokenResponse>>('/api/v1/admin/auth/refresh', data);
};

export const logout = (data: LogoutRequest) => {
  return service.post<ApiResponse<null>>('/api/v1/admin/auth/logout', data);
};

export const getCurrentAdmin = () => {
  return service.get<ApiResponse<AdminResponse>>('/api/v1/admin/auth/me');
};
